export enum Errors {
  LicenseNotFound = 'License not found',
  PeriodNotFound = 'Period not found',
  ReservationIdNotFound = 'Reservation id not found',
  PrinterNotFound = 'Printer not found',
}
